export const contentReviewStatusStyles = {
	Pending: {
		backgroundColor: '#F4F4F4',
		color: '#696969',
	},
	Passed: {
		backgroundColor: '#EDFFEE',
		color: '#3C982F',
	},
	Failed: {
		backgroundColor: '#FFF1F0',
		color: '#CC3939',
	},
};

export const contentReviewStatusOptions = [
	{
		label: 'Awaiting',
		value: 'Pending',
	},
	{
		label: 'Pass',
		value: 'Passed',
	},
	{
		label: 'Not Pass',
		value: 'Failed',
	},
];

export const channelOptions = [
	{
		label: 'DEP',
		value: 'dep-website',
	},
	{
		label: 'Official Account',
		value: 'official-wechat',
	},
	{
		label: 'Mini Program',
		value: 'mini-program',
	},
];

export const intentionOptions = [
	{
		label: 'Others',
		value: 'OTHER',
	},
	{
		label: 'Q&A',
		value: 'Q&A',
	},
	{
		label: 'Image Detection',
		value: 'IMAGE_DETECTIVE',
	},
	{
		label: 'Product Recommendation',
		value: 'PRODUCT_RECOMMENDATION',
	},
	{
		label: 'Document Download',
		value: 'DOCUMENT_DOWNLOAD',
	},
];

export const violationOptions = [
	{
		label: '政治敏感',
		value: 'political',
	},
	{
		label: '暴力',
		value: 'violence',
	},
	{
		label: '色情',
		value: 'pornography',
	},
	{
		label: '欺诈',
		value: 'fraud',
	},
	{
		label: '隐私泄漏',
		value: 'privacy leakage',
	},
];

export const imageSceneMapping = {
	0: '在生产线上',
	1: '仓库',
	2: '货架 / 物流中',
	3: '其他',
};
